// extracted by mini-css-extract-plugin
var _1 = "ColorPicker_customLayout__nPhoC";
var _2 = "ColorPicker_picker__XizsB";
var _3 = "ColorPicker_popover__k3YCK";
var _4 = "ColorPicker_swatch__qeSPZ";
var _5 = "ColorPicker_text__D6fvi";
export { _1 as "customLayout", _2 as "picker", _3 as "popover", _4 as "swatch", _5 as "text" }
